module.exports = __webpack_public_path__ + "static/media/vanessa-full.c6e0ff37.png";